var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTnsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 81.4 76.5",
    style: {
      enableBackground: "new 0 0 81.4 76.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FEFEFE;}\n\t.st1{fill:#24588D;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#24588D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 76.3,
    height: 76.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.4,26.3 76.3,26.3 76.3,0 0,0 0,10.8 75.4,27.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.2,1.5c0,0.9,0.7,1.5,1.5,1.5c0.8,0,1.5-0.6,1.5-1.5c0-0.8-0.7-1.5-1.5-1.5C78.9,0,78.2,0.6,78.2,1.5 L78.2,1.5z M78.5,1.5c0-0.7,0.5-1.3,1.2-1.3c0.7,0,1.2,0.6,1.2,1.3c0,0.7-0.5,1.3-1.2,1.3C79.1,2.8,78.5,2.2,78.5,1.5L78.5,1.5z  M79.2,2.4h0.3V1.6h0.3l0.5,0.8h0.3L80,1.6c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.6-0.5h-0.7V2.4L79.2,2.4z M79.4,0.8h0.4 c0.2,0,0.4,0,0.4,0.3c0,0.3-0.2,0.3-0.5,0.3h-0.3V0.8L79.4,0.8z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.4,28.3 0,16.4 0,21.5 75.4,28.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.4,29.4 0,27.2 0,32.3 75.4,30.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.4,30.6 0,38 0,43 75.4,31.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.4,33.2v-1.5L0,48.7v27.7h76.3V33.2H75.4z M48,59.5h-4.3v12.6h-3V59.5h-4.3v-2.4H48V59.5z M61.6,72.1H58 l-5.7-11.2h0v11.2h-2.9V57.1H53l5.7,11.2h0V57.1h2.9V72.1z M67,72.3c-1.6,0-2.6-0.2-4-0.6V69c1,0.6,2.7,0.9,3.9,0.9 c1.1,0,2.7-0.6,2.7-1.9c0-2.8-6.5-1.7-6.5-6.6c0-3.3,2.6-4.6,5.2-4.6c1.3,0,2.7,0.2,3.8,0.5v2.5c-0.9-0.4-2.5-0.6-3.5-0.6 c-1,0-2.4,0.4-2.4,2.1c0,2.6,6.5,1.5,6.5,6.5C72.6,71.1,70,72.3,67,72.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnsLogo);
export default __webpack_public_path__ + "static/media/tns-logo.194ea105ee36db1372f7f9331b3cd25b.svg";
export { ForwardRef as ReactComponent };